import React from 'react';
import { Tab } from '@mui/material';
import { CountLabel, RecordTabs } from 'components/record-shell/RecordShell';

interface SurgerieTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  counts: { payments: number; history: number };
}

const SurgerieTab: React.FC<SurgerieTabProps> = ({ tab, onChange, counts }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      <Tab value="main" label="Geral" />
      <Tab value="values" label="Valores" />
      <Tab value="payments" label={<CountLabel label="Pagamentos" count={counts.payments} />} />
      <Tab value="history" label={<CountLabel label="Histórico" count={counts.history} />} />
    </RecordTabs>
  );
};

export default SurgerieTab;
